import { render, staticRenderFns } from "./DfCorrectionModal.vue?vue&type=template&id=41c190fa"
import script from "./DfCorrectionModal.vue?vue&type=script&lang=js"
export * from "./DfCorrectionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports